(() => {
  const selector = '[data-promo-campaign]';
  let serverOffsetMs = 0;
  let boundaryTimer;

  const campaignNodes = () => Array.from(document.querySelectorAll(selector));

  const setVisibility = (node, visible) => {
    const changed = node.hidden !== !visible;
    node.hidden = !visible;
    node.setAttribute('aria-hidden', visible ? 'false' : 'true');
    return changed;
  };

  const render = () => {
    const nowSeconds = Math.floor((Date.now() + serverOffsetMs) / 1000);
    let nextBoundarySeconds = null;
    const changedCarousels = new Set();

    campaignNodes().forEach((node) => {
      const enabled = node.dataset.promoEnabled === 'true';
      const enforceDates = node.dataset.promoEnforceDates === 'true';
      const start = Number(node.dataset.promoStart || 0);
      const end = Number(node.dataset.promoEnd || 0);
      const visible = enabled && (!enforceDates || ((!start || nowSeconds >= start) && (!end || nowSeconds < end)));

      // Inverse nodes restore the default collection image outside the campaign.
      const nodeVisible = node.dataset.promoInvert === 'true' ? !visible : visible;
      if (setVisibility(node, nodeVisible)) {
        const carousel = node.closest('hero-banner, announcement-bar');
        if (carousel) changedCarousels.add(carousel);
      }

      if (enabled && enforceDates) {
        if (start > nowSeconds && (nextBoundarySeconds === null || start < nextBoundarySeconds)) nextBoundarySeconds = start;
        if (end > nowSeconds && (nextBoundarySeconds === null || end < nextBoundarySeconds)) nextBoundarySeconds = end;
      }
    });

    // Keen ignores same-width window resize events; force it to drop expired slides.
    changedCarousels.forEach((element) => element.carousel?.resize?.());
    window.dispatchEvent(new Event('resize'));
    clearTimeout(boundaryTimer);
    if (nextBoundarySeconds !== null) {
      const delay = Math.max(250, (nextBoundarySeconds * 1000) - (Date.now() + serverOffsetMs) + 150);
      boundaryTimer = window.setTimeout(render, Math.min(delay, 2147483647));
    }
  };

  const syncClock = async () => {
    const startedAt = Date.now();
    try {
      const response = await fetch(`/cart.js?campaign_clock=${startedAt}`, {
        cache: 'no-store',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      const receivedAt = Date.now();
      const serverDate = Date.parse(response.headers.get('Date') || '');
      if (Number.isFinite(serverDate)) {
        serverOffsetMs = serverDate + ((receivedAt - startedAt) / 2) - receivedAt;
      }
    } catch (error) {
      console.warn('Campaign clock sync failed; using the visitor clock.', error);
    }
    render();
  };

  render();
  syncClock();
  window.setInterval(syncClock, 60000);
  document.addEventListener('shopify:section:load', syncClock);
})();
